<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-5">Sutarties dokumento duomenys</h3>
    <div class="dataContainer mb-3">
      <template v-if="isPrasymasIregistravimas">
        <v-row>
          <v-col cols="12" md="6">
            <el-autocomplete
              label="Pardavėjo pareiškimas apie daiktą"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Pardavėjo pareiškimas apie daiktą`
              "
              :need="!isReadonlyForm"
              :readonly="isReadonlyForm"
              :items="pareiskimasList"
              itemvalue="value"
              itemtext="text"
              validate-key="pareiskimas"
              multiple
              v-model="formData.sut_pareiskimas"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <el-date-picker
              label="Sutarties terminas iki (data)"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Sutarties terminas iki (data)`
              "
              :readonly="isReadonlyForm"
              future-dates
              validate-key="sut_terminas_iki"
              v-model="formData.sut_terminas_iki"
            />
          </v-col>

          <v-col cols="12" md="12">
            <el-textarea
              label="Sutarties terminas iki (termino sąlyga)"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Sutarties terminas iki (termino sąlyga)`
              "
              :need="!isReadonlyForm"
              :readonly="isReadonlyForm"
              counter="4000"
              validate-key="sut_aprasymas"
              v-model="formData.sut_aprasymas"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="5">
            <el-money-field
              label="Avanso suma, EUR"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Avanso suma, EUR`"
              :readonly="isReadonlyForm"
              :need="!isReadonlyForm"
              :precision="2"
              validate-key="sut_suma"
              v-model="formData.sut_suma"
            />
          </v-col>
          <v-col cols="12" md="3">
            <el-checkbox
              :readonly="isReadonlyForm"
              class="mt-4 ml-4"
              label="Įskaičiuotas PVM"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Įskaičiuotas PVM`"
              v-model="formData.sut_iskaiciuotas_pvm"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-date-picker
              label="Avanso sumokėjimo data iki"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Avanso sumokėjimo data iki`
              "
              :readonly="isReadonlyForm"
              :need="!isReadonlyForm"
              validate-key="sut_perdavimo_data"
              v-model="formData.sut_perdavimo_data"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Kita avanso mokėjimo informacija"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kita avanso mokėjimo informacija`
              "
              counter="4000"
              :rows="informacijaRows"
              :placeholder="placeholderMokejimoInformacija"
              validate-key="sut_mokejimo_informacija"
              v-model="formData.sut_mokejimo_informacija"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <el-autocomplete
              label="Pagrindinės sutarties notarinio tvirtinimo išlaidas apmoka"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Pagrindinės sutarties notarinio tvirtinimo išlaidas apmoka`
              "
              :readonly="isReadonlyForm"
              :need="!isReadonlyForm"
              :items="apmokaList"
              itemvalue="value"
              itemtext="text"
              validate-key="sut_apmoka_kla_id"
              v-model="formData.sut_apmoka_kla_id"
            />
          </v-col>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Kitos pagrindinės sutarties šalių numatytos sąlygos"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kitos pagrindinės sutarties šalių numatytos sąlygos`
              "
              counter="4000"
              validate-key="sut_salygos"
              v-model="formData.sut_salygos"
            />
          </v-col>
        </v-row>
      </template>

      <template v-if="!isPrasymasIregistravimas">
        <v-row class="pt-3">
          <v-col cols="12" md="4">
            <el-text-field
              label="Sutarties numeris"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Sutarties numeris`"
              :readonly="true"
              validate-key="sut_numeris"
              v-model="formData.sut_numeris"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-text-field
              :label="sutartisDataLabel"
              :tooltip="`${ntrTooltipPrefix} Sutartis. ${sutartisDataLabel}`"
              :readonly="true"
              validate-key="sut_data"
              v-model="formData.sut_data"
            />
          </v-col>

          <v-col cols="12" md="4" v-if="isPrasymasIsregistravimas">
            <el-text-field
              label="Sutarties pabaigos data"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Sutarties pabaigos data`"
              :readonly="true"
              validate-key="sut_pabaigos_data"
              v-model="formData.sut_pabaigos_data"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="isPrasymasNutraukimas">
            <el-date-picker
              label="Sutarties nutraukimo data"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Sutarties nutraukimo data`
              "
              :need="!isReadonlyForm"
              :readonly="isReadonlyForm"
              validate-key="sut_nutraukimo_data"
              v-model="formData.sut_nutraukimo_data"
            />
          </v-col>
        </v-row>
      </template>

      <v-row v-if="isPrasymasNutraukimas">
        <v-col cols="12" md="12">
          <el-textarea
            :readonly="isReadonlyForm"
            :need="!isReadonlyForm"
            label="Avanso grąžinimo sąlygos"
            :tooltip="`${ntrTooltipPrefix} Sutartis. Avanso grąžinimo sąlygos`"
            counter="4000"
            validate-key="sut_avansas_grazinimas"
            v-model="formData.sut_avansas_grazinimas"
          />
        </v-col>
        <v-col cols="12" md="12">
          <el-textarea
            :readonly="isReadonlyForm"
            label="Kitos susitarimo sąlygos"
            :tooltip="`${ntrTooltipPrefix} Sutartis. Kitos susitarimo sąlygos`"
            counter="4000"
            validate-key="salygos"
            v-model="formData.sut_salygos"
          />
        </v-col>
      </v-row>
    </div>

    <template v-if="isPrasymasIregistravimas">
      <h3 class="mb-5">
        Šalių įsipareigojimai, jei nepasirašoma pagrindinė sutartis
      </h3>
      <div class="dataContainer mb-3">
        <v-row>
          <v-col cols="12" md="6">
            <el-text-field
              :readonly="isReadonlyForm"
              :need="!isReadonlyForm"
              label="Avanso grąžinimo k.d. skaičius"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Avanso grąžinimo k.d. skaičius`
              "
              v-mask="`###`"
              validate-key="sut_avansas_dienos"
              v-model="formData.sut_avansas_dienos"
            >
            </el-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Kita avanso grąžinimo informacija"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kita avanso grąžinimo informacija`
              "
              counter="4000"
              :rows="informacijaRows"
              :placeholder="placeholderAvansasGrazinimas"
              validate-key="sut_avansas_grazinimas"
              v-model="formData.sut_avansas_grazinimas"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Kitos sąlygos, jeigu pagrindinė sutartis nepasirašoma dėl pardavėjo kaltės"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kitos sąlygos, jeigu pagrindinė sutartis nepasirašoma dėl pardavėjo kaltės`
              "
              counter="4000"
              validate-key="sut_kalte_pardavejas"
              v-model="formData.sut_kalte_pardavejas"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Kitos sąlygos, jeigu pagrindinė sutartis nepasirašoma dėl pirkėjo kaltės"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kitos sąlygos, jeigu pagrindinė sutartis nepasirašoma dėl pirkėjo kaltės`
              "
              counter="4000"
              validate-key="sut_kalte_pirkejas"
              v-model="formData.sut_kalte_pirkejas"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Kiti šalių įsipareigojimai"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kiti šalių įsipareigojimai`
              "
              counter="4000"
              validate-key="sut_isipareigojimai"
              v-model="formData.sut_isipareigojimai"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Kiti sutarties nutraukimo pagrindai"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kiti sutarties nutraukimo pagrindai`
              "
              counter="4000"
              validate-key="sut_nutraukimo_pagrindai"
              v-model="formData.sut_nutraukimo_pagrindai"
            />
          </v-col>
        </v-row>
      </div>
    </template>

    <v-footer class="form-footer" v-if="!isReadonly">
      <el-button
        v-if="!isReadonlyForm"
        primary
        @click.native="saveData()"
        :loading="loading"
        >Saugoti</el-button
      >
      <el-button
        v-if="!isReadonlyForm"
        @click.native="cancelData()"
        :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
      <el-button primary @click.native="checkErrorsClick()" :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import unsavedData from '@/mixins/unsavedData'
import checkErrors from '@/mixins/checkErrors'

export default {
  name: 'RegPrasymasSutartisPreliminari',
  props: {
    readonlyForm: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  mixins: [userRole, busena, unsavedData, checkErrors, tooltipNtr],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      formData: {},
      pareiskimasList: [],
      apmokaList: [],
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    isReadonly() {
      return this.readonly
    },
    isReadonlyForm() {
      return this.readonlyForm
    },
    informacijaRows() {
      if (this.isReadonlyForm) {
        return 1
      }
      return 4
    },
    placeholderMokejimoInformacija() {
      if (this.isReadonlyForm) {
        return ''
      }
      return (
        `Daikto1 unikalus numeris, avanso sumos dalis, banko sąskaita 1 Asmuo\n` +
        `Daikto2 unikalus numeris, avanso sumos dalis, banko sąskaita 2 Asmuo\n` +
        `Daikto3 unikalus numeris, avanso sumos dalis, banko sąskaita 3 Asmuo`
      )
    },
    placeholderAvansasGrazinimas() {
      if (this.isReadonlyForm) {
        return ''
      }
      return (
        `Grąžinamo avanso sumos dalis, banko sąskaita 1 Asmuo\n` +
        `Grąžinamo avanso sumos dalis, banko sąskaita 2 Asmuo\n` +
        `Grąžinamo avanso sumos dalis, banko sąskaita 3 Asmuo`
      )
    },
    sutartisDataLabel() {
      if (this.isPrasymasIsregistravimas) {
        return 'Sutarties pradžios data'
      }
      return 'Sutarties data'
    },
  },
  created() {
    this.getKlasif()
  },
  methods: {
    getKlasif() {
      const data = {
        klasifikatoriai: [
          'preliminari_pardavejo_pareiskimas',
          'preliminari_apmoka',
        ],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.pareiskimasList = res.data.list.preliminari_pardavejo_pareiskimas
          this.apmokaList = res.data.list.preliminari_apmoka
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.getData()
        })
    },
    getData() {
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/sutartis`)
        .then(res => {
          this.formData = res.data.sutartis
          this.$nextTick(() => {
            this.initialForm()
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      if (toRoute && this.isReadonlyForm) {
        this.goToRoute()
        return
      }
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.pra_id = this.prasymasID

          this.$axios
            .post(`ntrpaslaugos/prasymas/${this.prasymasID}/sutartis`, data)
            .then(res => {
              if (toRoute) {
                this.goToRoute()
              } else {
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkNtrErrors()
                }
              }
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    checkErrorsClick() {
      if (this.isReadonlyForm) {
        this.checkNtrErrors()
        return
      }
      this.saveData(null, 'checkErrors')
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 1400px;
}
</style>
